/**
 * Test IDs for QA automation.
 */
export const testIds = {
  businessLocationsListStatusNavigation: "business-locations-list-status-navigation",
  businessLocationsListAll: "business-locations-list-all",
  businessLocationsListActiveEntityType: "business-locations-list-active-entity-type",
  businessLocationsListNewLocation: "business-locations-list-new-location",
} as const;
